import {FORCE_HIDE_COPILOT_SEARCH_PARAM} from 'common/src/modules/shared/copilot/copilot.consts';
import {Resource} from '../../../copilot.types';
import {FCResource} from '../resourceKnowledgeTool.types';

function buildResources(
  resources: FCResource[],
  linkBuilder: (resource?: FCResource) => Resource,
): Resource[] {
  // if no resources, we want to show the link to all resources, so we pass undefined
  const resourcesOrUndefined = resources.length === 0 ? [undefined] : resources;

  return resourcesOrUndefined.map(linkBuilder).map((resource) => {
    const existingQueryParams = resource.link.queryParams || {};

    return {
      ...resource,
      link: {
        ...resource.link,
        queryParams: {
          ...existingQueryParams,
          [FORCE_HIDE_COPILOT_SEARCH_PARAM]: 'true',
        },
      },
    };
  });
}

export default buildResources;
